<template>
    <rkm-overlay>
        <rkm-layout-body title="Unificação de usuário/paciente">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.handleStore()"
                    color="primary"
                >
                    Unificar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form ref="Form" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/unificacao-usuario-paciente/Form'

export default {
    components: {Form},
}
</script>